module.exports = __webpack_public_path__ + "static/media/sophie.fe093095.jpg";